import config from "../permission/config.json";
import { getResource } from "./getResourcePermission";
import { getRoles } from "./getRoles";

/**
 * Who sees Payroll Readiness (header tile + page): Admin always, anyone else only
 * with read on the "Payroll Readiness" resource (seeded for HR).
 * Mirrors the server guard requireGrantedResourcePermission("Payroll Readiness", "read").
 */
const canViewPayrollReadiness = () => {
  if (getRoles(["Admin"])) return true;
  const resourceName = config.RESOURCES?.PAYROLL_READINESS;
  return !!resourceName && getResource(resourceName, ["read"]);
};

export default canViewPayrollReadiness;
